import {VEHICLE_TYPE} from './types';

export const getVehicle = data => ({
  type: VEHICLE_TYPE,
  payload: data,
});
